import type { CalendarEventNotifyCustomersReason } from '~/libs/gql/types';

export type CalendarEventToDelete = {
  hasSoldTickets: boolean;
  id: number;
  isCanceled: boolean;
  name: string;
};

export type CalendarEventToNotify = {
  id: number;
  name: string;
  reason: CalendarEventNotifyCustomersReason;
};

export type CalendarEventsState = {
  calendarEventToDelete: CalendarEventToDelete | null;
  calendarEventToNotify: CalendarEventToNotify | null;
  copyEventById: number | null;
  showCreateCalendarEventStepper: boolean;
  successDialogCalendarEventId: number | null;
};

export type CalendarEventsEvent =
  | { type: 'calendarEvents.closeCreateCalendarEventStepper' }
  | { type: 'calendarEvents.closeCreateCalendarEventSuccessDialog' }
  | { type: 'calendarEvents.closeDeleteEventDialog' }
  | { type: 'calendarEvents.closeNotifyCustomersDialog' }
  | { type: 'calendarEvents.openCreateCalendarEventStepper' }
  | { calendarEventId: number, type: 'calendarEvents.openCreateCalendarEventStepperToCopy' }
  | { calendarEventId: number, type: 'calendarEvents.openCreateCalendarEventSuccessDialog' }
  | {
    calendarEventId: number
    calendarEventName: string
    hasSoldTickets: boolean
    isCanceled: boolean
    type: 'calendarEvents.openDeleteEventDialog'
  }
  | {
    calendarEventId: number
    calendarEventName: string
    reason: CalendarEventNotifyCustomersReason
    type: 'calendarEvents.openNotifyCustomersDialog'
  };

export const calendarEventsInitialState: CalendarEventsState = {
  calendarEventToDelete: null,
  calendarEventToNotify: null,
  copyEventById: null,
  showCreateCalendarEventStepper: false,
  successDialogCalendarEventId: null,
};

export const calendarEventsReducer = (
  prevState: CalendarEventsState = calendarEventsInitialState,
  event: CalendarEventsEvent,
): CalendarEventsState => {
  switch (event.type) {
    case 'calendarEvents.closeCreateCalendarEventStepper':
      return {
        ...prevState,
        copyEventById: null,
        showCreateCalendarEventStepper: false,
      };
    case 'calendarEvents.closeCreateCalendarEventSuccessDialog':
      return {
        ...prevState,
        successDialogCalendarEventId: null,
      };
    case 'calendarEvents.closeDeleteEventDialog':
      return {
        ...prevState,
        calendarEventToDelete: null,
      };
    case 'calendarEvents.closeNotifyCustomersDialog':
      return {
        ...prevState,
        calendarEventToNotify: null,
      };
    case 'calendarEvents.openCreateCalendarEventStepper':
      return {
        ...prevState,
        showCreateCalendarEventStepper: true,
      };
    case 'calendarEvents.openCreateCalendarEventStepperToCopy':
      return {
        ...prevState,
        copyEventById: event.calendarEventId,
        showCreateCalendarEventStepper: true,
      };
    case 'calendarEvents.openCreateCalendarEventSuccessDialog':
      return {
        ...prevState,
        successDialogCalendarEventId: event.calendarEventId,
      };
    case 'calendarEvents.openDeleteEventDialog':
      return {
        ...prevState,
        calendarEventToDelete: {
          hasSoldTickets: event.hasSoldTickets,
          id: event.calendarEventId,
          isCanceled: event.isCanceled,
          name: event.calendarEventName,
        },
      };
    case 'calendarEvents.openNotifyCustomersDialog':
      return {
        ...prevState,
        calendarEventToNotify: {
          id: event.calendarEventId,
          name: event.calendarEventName,
          reason: event.reason,
        },
      };
    default:
      return prevState;
  }
};
